import { SortOrder } from '@portal/shared/ui/table';
import { ICriteria } from './criteria.interface';

export interface IOnDemandReportRequest {
  criteria?: ICriteria[];
  direction?: SortOrder;
  fields?: string[];
  id: string;
  pageNumber?: number;
  orderCriteria?: string;
  pageSize?: number;
  name?: string;
  query?: string;
  source?: string;
  useEntityService?: number;
}
